const art = () => (
    <svg
        width="190"
        height="122"
        viewBox="0 0 190 122"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.636525 0.563477L187.672 0.850379L187.622 11.8849H0.669454C0.654056 8.11116 0.614195 4.33725 0.636525 0.563477Z"
            fill="#CAE4FE"
        />
        <path
            d="M131.503 59.4351C131.663 87.1916 131.889 112.707 132.356 113.687C142.854 115.689 180.867 114.732 180.864 114.297C180.844 111.863 180.964 64.7381 180.922 59.5907L131.503 59.4351Z"
            fill="white"
        />
        <path
            d="M131.503 59.4351C131.663 87.1916 131.889 112.707 132.356 113.687C142.854 115.689 180.867 114.732 180.864 114.297C180.844 111.863 180.964 64.7381 180.922 59.5907L131.503 59.4351Z"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M177.561 61.6995C177.006 62.4211 174.459 64.5552 174.431 64.5296C174.274 64.3863 171.757 62.1573 171.383 61.7806L177.561 61.6995Z"
            fill="#CAE4FE"
        />
        <path
            d="M165.245 98.6576C184.026 83.1453 154.898 59.6201 142.149 79.5304C140.246 82.5017 139.702 85.3775 140.009 88.5405C140.983 98.5649 152.482 106.539 165.107 98.7608L165.245 98.6576Z"
            fill="white"
        />
        <path
            d="M165.245 98.6576C184.026 83.1453 154.898 59.6201 142.149 79.5304C140.246 82.5017 139.702 85.3775 140.009 88.5405C140.983 98.5649 152.482 106.539 165.107 98.7608L165.245 98.6576Z"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M165.592 75.8511C170.349 79.5579 173.773 86.1823 170.883 92.2672C169.59 92.0231 168.339 91.6585 167.061 91.3727C165.551 91.0676 154.057 89.1794 153.971 88.3473C154.284 87.4751 155.53 86.2699 156.178 85.5742C156.963 84.7317 157.947 83.715 158.72 82.9233C161.013 80.5733 163.401 78.2838 165.592 75.8511Z"
            fill="white"
        />
        <path
            d="M165.592 75.8511C170.349 79.5579 173.773 86.1823 170.883 92.2672C169.59 92.0231 168.339 91.6585 167.061 91.3727C165.551 91.0676 154.057 89.1794 153.971 88.3473C154.284 87.4751 155.53 86.2699 156.178 85.5742C156.963 84.7317 157.947 83.715 158.72 82.9233C161.013 80.5733 163.401 78.2838 165.592 75.8511Z"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M164.964 75.2668C166.228 76.3032 165.801 75.8941 166.328 76.4107C161.904 79.838 157.942 83.7607 154.077 87.7387L153.971 87.2118C154.034 85.3815 154.28 82.0405 154.532 80.2282C154.887 76.9341 154.518 75.1548 155.462 71.8887C159.171 71.9161 162.119 73.3251 164.964 75.2668Z"
            fill="white"
        />
        <path
            d="M164.964 75.2668C166.228 76.3032 165.801 75.8941 166.328 76.4107C161.904 79.838 157.942 83.7607 154.077 87.7387L153.971 87.2118C154.034 85.3815 154.28 82.0405 154.532 80.2282C154.887 76.9341 154.518 75.1548 155.462 71.8887C159.171 71.9161 162.119 73.3251 164.964 75.2668Z"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M124.762 54.3673C124.753 35.5178 124.56 18.1914 123.469 17.532C98.6767 16.3092 8.79707 17.455 8.79967 17.75C8.81395 19.4034 7.9018 51.4109 7.93137 54.9064L124.762 54.3673Z"
            fill="white"
        />
        <path
            d="M124.762 54.3673C124.753 35.5178 124.56 18.1914 123.469 17.532C98.6767 16.3092 8.79707 17.455 8.79967 17.75C8.81395 19.4034 7.9018 51.4109 7.93137 54.9064L124.762 54.3673Z"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.4805 25.4607C22.4046 25.4767 27.2912 25.5435 32.0843 24.9045"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.4805 29.4358C41.0353 29.3696 64.7088 30.5653 88.253 30.5653"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.4805 34.5588C44.6333 33.0248 72.5028 36.8925 99.4867 33.9617"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.4805 39.6223C29.2692 39.6366 41.055 39.9098 52.8667 39.9098"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.4805 45.2832C34.346 45.855 51.141 45.8493 68.0323 45.8493"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M120.831 20.9419C120.275 21.6636 117.729 23.7976 117.701 23.772C117.543 23.6287 115.026 21.3998 114.652 21.0231L120.831 20.9419Z"
            fill="#CAE4FE"
        />
        <path
            d="M124.762 59.8044C124.684 87.5026 124.427 112.963 123.333 113.936C98.5365 115.823 8.66032 114.464 8.66399 114.031C8.68441 111.601 7.89022 64.5715 7.93334 59.4351L124.762 59.8044Z"
            fill="white"
        />
        <path
            d="M124.762 59.8044C124.684 87.5026 124.427 112.963 123.333 113.936C98.5365 115.823 8.66032 114.464 8.66399 114.031C8.68441 111.601 7.89022 64.5715 7.93334 59.4351L124.762 59.8044Z"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M15.2334 68.4922C15.9097 72.9193 15.7857 104.833 16.5235 105.568C84.4561 105.568 107.181 106.21 112.405 105.568"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M23.0977 105.171C23.2048 101.512 23.1304 86.8354 23.3186 86.7644C23.7914 86.5862 34.4467 86.4766 34.9881 86.8994C35.8807 87.5964 36.0165 103.066 36.0165 105.287"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M47.3698 105.853C47.3698 101.995 47.1334 81.8095 47.3248 81.7173C47.8054 81.4856 58.636 81.3433 59.1862 81.8927C60.0935 82.7986 60.1688 102.687 60.1688 105.573"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M69.2656 105.287C70.0408 101.865 68.9891 75.0821 69.1786 74.9695C69.6547 74.6868 80.3837 74.5132 80.9288 75.1836C81.8276 76.2889 82.0741 101.417 82.0741 104.938"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M93.4251 104.802C93.4251 101.021 93.1933 81.2374 93.3809 81.147C93.8522 80.92 104.471 80.7805 105.011 81.319C105.9 82.2068 105.624 103.025 105.624 105.853"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M180.931 16.9962C180.841 35.9962 180.68 53.4616 180.216 54.1311C169.721 55.4755 131.7 54.7257 131.703 54.4283C131.716 52.7616 131.477 20.503 131.505 16.9795L180.931 16.9962Z"
            fill="white"
        />
        <path
            d="M180.931 16.9962C180.841 35.9962 180.68 53.4616 180.216 54.1311C169.721 55.4755 131.7 54.7257 131.703 54.4283C131.716 52.7616 131.477 20.503 131.505 16.9795L180.931 16.9962Z"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M138.805 46.4152C145.792 32.8707 150.911 44.8912 156.279 41.7763C158.936 40.2343 160.61 32.8618 164.502 33.4263C167.879 33.9161 167.956 39.9112 173.068 38.1811"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M177.561 19.2439C177.006 19.9656 174.459 22.0997 174.431 22.074C174.274 21.9308 171.757 19.7018 171.383 19.325L177.561 19.2439Z"
            fill="#CAE4FE"
        />
        <path
            d="M138.368 24.3384C138.368 26.3772 138.087 44.052 138.368 48.6181C138.385 48.8929 168.65 48.1564 173.629 48.1564"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M188.13 0.848362C187.879 61.1915 187.353 116.661 185.599 118.785C145.914 123.006 2.11227 120.446 2.12006 119.502C2.16377 114.208 1.1049 11.7538 1.1971 0.563477L188.13 0.848362Z"
            fill="#EDF4FF"
        />
        <path
            d="M1.19805 0.563477L188.13 0.853665L188.08 12.0146H1.23096C1.21557 8.19767 1.17573 4.38054 1.19805 0.563477Z"
            fill="#171F66"
        />
        <path
            d="M130.917 59.1663C131.077 87.0467 131.302 112.676 131.768 113.66C142.242 115.671 180.17 114.71 180.166 114.273C180.146 111.828 180.267 64.493 180.225 59.3227L130.917 59.1663Z"
            fill="#CAE4FE"
        />
        <path
            d="M177.524 61.8606C176.983 62.6366 174.499 64.9317 174.471 64.9042C174.318 64.7501 171.863 62.353 171.498 61.9478L177.524 61.8606Z"
            fill="white"
        />
        <path
            d="M165.627 98.8798C184.468 83.2827 155.247 59.629 142.458 79.648C140.549 82.6356 140.003 85.5272 140.311 88.7074C141.288 98.7866 152.823 106.805 165.489 98.9836L165.627 98.8798Z"
            fill="#4F8EF9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M166.735 97.9027C166.386 98.2316 166.017 98.5574 165.627 98.8798L165.489 98.9836C161.946 101.172 158.49 102.12 155.33 102.13C154.886 98.0604 154.322 91.1674 154.179 87.105L154.992 87.5039C156.37 88.8365 158.021 90.0016 159.671 91.1666C162.467 93.1404 165.263 95.1142 166.735 97.9027Z"
            fill="#1EC794"
        />
        <path
            d="M165.687 75.3325C170.387 79.0626 173.772 85.7284 170.915 91.8516C169.638 91.606 168.401 91.2391 167.138 90.9514C165.646 90.6445 154.287 88.7445 154.201 87.9071C154.511 87.0295 155.743 85.8167 156.383 85.1167C157.158 84.2689 158.131 83.2458 158.895 82.4491C161.161 80.0844 163.521 77.7805 165.687 75.3325Z"
            fill="#FFC100"
        />
        <path
            d="M165.547 75.2011C166.832 76.2534 166.419 76.0235 166.955 76.5479C162.456 80.0279 158.241 84.0186 154.309 88.0576L154.201 87.5226C154.266 85.6642 154.758 75.2807 155.718 71.9646C159.49 71.9924 162.654 73.2296 165.547 75.2011Z"
            fill="#FF8100"
        />
        <path
            d="M180.226 16.7464C180.136 35.7019 179.976 53.1266 179.512 53.7945C169.043 55.1358 131.114 54.3877 131.116 54.091C131.13 52.4281 130.891 20.245 130.919 16.7297L180.226 16.7464Z"
            fill="white"
        />
        <path
            d="M177.524 19.4241C176.983 20.2002 174.499 22.4952 174.471 22.4677C174.318 22.3136 171.863 19.9165 171.498 19.5114L177.524 19.4241Z"
            fill="#CAE4FE"
        />
        <path
            d="M124.29 54.2423C124.281 35.3299 124.089 17.9457 123.001 17.2842C98.2907 16.0572 8.7073 17.2068 8.70989 17.5028C8.72413 19.1618 7.81498 51.2761 7.84445 54.7832L124.29 54.2423Z"
            fill="white"
        />
        <path
            d="M17.8232 25.4982C22.6926 25.5179 27.5249 25.6002 32.2646 24.813"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.8232 29.5302C41.3997 29.4767 65.0948 30.4425 88.6606 30.4425"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.8232 35.1645C41.3997 35.111 65.0948 36.0767 88.6606 36.0767"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.8232 40.7988C30.5447 40.7453 43.3302 41.711 56.0458 41.711"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M17.8232 45.0208C34.5842 45.7118 51.2752 45.7049 68.0617 45.7049"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M120.978 20.7712C120.436 21.5474 117.952 23.8424 117.925 23.8148C117.771 23.6608 115.316 21.2636 114.951 20.8585L120.978 20.7712Z"
            fill="#CAE4FE"
        />
        <path
            d="M124.292 59.5361C124.214 87.2699 123.957 112.763 122.867 113.737C98.1517 115.627 8.56998 114.266 8.57364 113.832C8.59399 111.399 7.8024 64.3093 7.84544 59.1663L124.292 59.5361Z"
            fill="white"
        />
        <path
            d="M22.2793 105.027C22.3631 98.8743 22.3049 74.1941 22.4522 74.0747C22.8223 73.775 31.1611 73.5909 31.5848 74.3017C32.2834 75.4739 32.3897 101.488 32.3897 105.222"
            fill="#4F8EF9"
        />
        <path
            d="M37.2071 105.24C37.2071 103.027 37.022 91.4461 37.1718 91.3932C37.5479 91.2603 46.024 91.1786 46.4547 91.4938C47.1647 92.0136 47.2236 103.424 47.2236 105.079"
            fill="#FF8700"
        />
        <path
            d="M66.8741 105.804C66.8741 103.989 66.689 94.4925 66.8388 94.4491C67.2149 94.3401 75.691 94.2732 76.1217 94.5317C76.8317 94.9578 76.8906 104.314 76.8906 105.672"
            fill="#47B8C5"
        />
        <path
            d="M81.7071 105.804C81.7071 104.896 81.522 100.148 81.6718 100.126C82.0479 100.072 90.524 100.038 90.9547 100.168C91.6648 100.381 91.7236 105.059 91.7236 105.738"
            fill="#1B2653"
        />
        <path
            d="M96.2432 106C96.2432 103.464 96.0582 90.1956 96.2079 90.135C96.5841 89.9827 105.06 89.8892 105.49 90.2503C106.201 90.8457 106.259 103.919 106.259 105.816"
            fill="#1EC794"
        />
        <path
            d="M52.041 105.599C52.041 102.493 51.856 86.2396 52.0058 86.1653C52.3819 85.9788 60.858 85.8642 61.2887 86.3066C61.9987 87.036 62.0576 103.05 62.0576 105.373"
            fill="#FFC100"
        />
        <path
            d="M15.8271 68.5967C16.5015 73.0159 16.3779 104.873 17.1134 105.606C84.8461 105.606 107.504 106.247 112.713 105.606"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M138.36 24.1394C138.36 26.1832 138.079 43.9006 138.36 48.4777C138.377 48.7531 168.546 48.0148 173.511 48.0148"
            stroke="#CAE4FE"
            strokeWidth="0.717647"
        />
        <path
            d="M163.963 99.854C161.313 96.7435 156.944 91.319 154.532 88.0216L155.43 87.8948C160.703 88.8128 166.999 87.458 171.462 90.1763C170.772 93.139 168.945 96.1342 165.628 98.8798L165.49 98.9836C164.979 99.2992 164.469 99.5891 163.963 99.854Z"
            fill="#1B2653"
        />
        <path
            d="M171.945 87.3858C171.919 88.8937 171.6 90.4197 170.917 91.9135C169.665 91.6679 168.452 91.301 167.214 91.0133C165.752 90.7064 154.616 88.8064 154.532 87.969C154.557 87.8988 154.587 87.8264 154.622 87.7523C160.362 87.2001 165.895 87.3294 171.945 87.3858Z"
            fill="#47B8C5"
        />
        <path
            d="M146.388 38.3131C147.474 38.3131 148.354 37.4302 148.354 36.3411C148.354 35.252 147.474 34.3691 146.388 34.3691C145.302 34.3691 144.422 35.252 144.422 36.3411C144.422 37.4302 145.302 38.3131 146.388 38.3131Z"
            fill="#4F8EF9"
        />
        <path
            d="M148.966 45.944C150.052 45.944 150.932 45.0611 150.932 43.972C150.932 42.8829 150.052 42 148.966 42C147.88 42 147 42.8829 147 43.972C147 45.0611 147.88 45.944 148.966 45.944Z"
            fill="#1EC794"
        />
        <path
            d="M152.005 31.5519C153.091 31.5519 153.971 30.669 153.971 29.5799C153.971 28.4908 153.091 27.6079 152.005 27.6079C150.919 27.6079 150.039 28.4908 150.039 29.5799C150.039 30.669 150.919 31.5519 152.005 31.5519Z"
            fill="#FF8100"
        />
        <path
            d="M159.868 44.5109C160.954 44.5109 161.834 43.628 161.834 42.5389C161.834 41.4498 160.954 40.5669 159.868 40.5669C158.783 40.5669 157.902 41.4498 157.902 42.5389C157.902 43.628 158.783 44.5109 159.868 44.5109Z"
            fill="#FFC100"
        />
        <path
            d="M165.485 37.7497C166.571 37.7497 167.451 36.8668 167.451 35.7777C167.451 34.6886 166.571 33.8057 165.485 33.8057C164.4 33.8057 163.52 34.6886 163.52 35.7777C163.52 36.8668 164.4 37.7497 165.485 37.7497Z"
            fill="#47B8C5"
        />
        <path
            d="M169.979 44.5109C171.064 44.5109 171.945 43.628 171.945 42.5389C171.945 41.4498 171.064 40.5669 169.979 40.5669C168.893 40.5669 168.013 41.4498 168.013 42.5389C168.013 43.628 168.893 44.5109 169.979 44.5109Z"
            fill="#1B2653"
        />
    </svg>
);

export default art;
